export function naturalCompare(a, b) {
    return a.localeCompare(b, undefined, { numeric: true });
}
export function matchRank(label, query) {
    const haystack = label.trim().toLowerCase();
    const needle = query.trim().toLowerCase();
    if (haystack === needle)
        return 0;
    if (haystack.startsWith(needle))
        return 1;
    if (new RegExp(`\\b${needle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`).test(haystack))
        return 2;
    if (haystack.includes(needle))
        return 3;
    return null;
}
export function rankOptions(options, query, matches) {
    if (query.trim() === '')
        return options;
    return options
        .map(option => ({
        option,
        rank: matches ? (matches(option, query) ? matchRank(option.label, query) ?? 4 : null) : matchRank(option.label, query),
    }))
        .filter((scored) => scored.rank !== null)
        .sort((a, b) => a.rank - b.rank)
        .map(scored => scored.option);
}
export function sortOptionsByLabel(options) {
    return [...options].sort((a, b) => naturalCompare(a.label, b.label));
}
